import { types } from "../actions";
import { getDeviceMappingCollection } from "../../api/DeviceServiceManager";
const initialState = {
  activatedSensors: [],
  showSensorActivatedModal: false,
  activationStatusMessage:
    "Your requested sensor activation failed. Please try again.",
  cameraList: [],
  reportData: [],
  discoveredCamerasList: [],
  companionDeviceList: [],
  ccdUpdateList: [],
  fovList: [],
  roiList: [],
  deviceList: [],
  cameraUpdatedDate: "",
  discoveredUpdatedDate: "",
  locationDeviceMapping: {},
  refreshCameraStatus: false,
  cameraUpdateStatus: {},
  cameraCalibrationStatus: false,
  cameraCreds: {
    loading: false,
    error: null,
    data: {},
  },
};
const deviceReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.ACTIVATE_SENSOR_SUCCESS: {
      return {
        ...state,
        activatedSensors: [...state.activatedSensors, action.payload],
        showSensorActivatedModal: true,
      };
    }
    case types.SET_SHOW_SENSOR_ACTIVATE_MODAL: {
      console.log("action->", action);
      return {
        ...state,
        showSensorActivatedModal: action.modalState.showSensorActivatedModal,
      };
    }
    case types.FETCHED_CAMERA_DEVICES: {
      return {
        ...state,
        cameraList: action.cameraDeviceList,
      };
    }
    case types.SELECTED_CAMERA_INFO: {
      return {
        ...state,
        selectedCameraInfo: action.cameraInfo,
      };
    }
    case types.UPDATE_CAMERA_UPDATED_LIST: {
      return {
        ...state,
        cameraList: action.cameraList,
      };
    }

    case types.UPDATE_FOV_UPDATED_LIST: {
      return {
        ...state,
        fovList: action.fovList || [],
      };
    }

    case types.CAMERA_UPDATED_DATE: {
      return {
        ...state,
        cameraUpdatedDate: action.date,
      };
    }

    case types.DISCOVERED_UPDATED_DATE: {
      return {
        ...state,
        discoveredUpdatedDate: action.date,
      };
    }

    case types.UPDATE_CAMERA_ON_BOARED_DETAILS: {
      return {
        ...state,
        cameraUpdateStatus: action.payload,
      };
    }
    

    case types.FETCHED_COMPANION_DEVICES: {
      return {
        ...state,
        companionDeviceList: action.companionDeviceList,
      };
    }

    case types.UPDATE_COMPANION_DEVICE_SITE: {
      return {
        ...state,
        companionDeviceList: action.companionDeviceList,
      };
    }

    case types.UPDATE_ROILIST: {
      return {
        ...state,
        roiList: action.roiList,
        locationDeviceMapping: getDeviceMappingCollection(action.roiList),
      };
    }

    case types.FETCHED_UN_PAIRED_CAMERA_DEVICES: {
      return {
        ...state,
        discoveredCamerasList: action.discoveredCamerasList,
      };
    }
    case types.UPDATE_ALL_DEVICES: {
      return {
        ...state,
        cameraList: action?.devices?.cameraList,
        fovList: action?.devices?.fovList,
        deviceList: [
          ...action?.devices?.cameraList,
          ...action?.devices?.fovList,
        ],
      };
    }

    case types.REMOVE_CAMERA_FROM_LIST: {
      const updatedCameraList = (state.cameraList || []).filter(
        (camera) => camera.id !== action.cameraId
      );
      return {
        ...state,
        cameraList: updatedCameraList,
        deviceList: [...updatedCameraList, ...(state.fovList || [])],
      };
    }

    case types.REFRESH_CAMERA_PAGE: {
      return {
        ...state,
        refreshCameraStatus: action.value,
      };
    }

    case types.CAMERA_CALIBRATION_UPDATE_STATUS: {
      return {
        ...state,
        cameraCalibrationStatus: action.value,
      };
    }

    case types.UPDATE_CCD_STATUS: {
      const { id, fields } = action?.payload;
      const existingIndex = state?.ccdUpdateList?.findIndex(
        (item) => item.id === id
      );

      if (existingIndex !== -1) {
        // Update the fields of the existing item
        const updatedList = state?.ccdUpdateList?.map((item, idx) =>
          idx === existingIndex ? { ...item, fields } : item
        );
        return {
          ...state,
          ccdUpdateList: updatedList,
        };
      } else {
        // Add the new item
        return {
          ...state,
          ccdUpdateList: [...state?.ccdUpdateList, action?.payload],
        };
      }
    }

    case types.GET_CAMERA_CREDS_REQUEST: {
      return {
        ...state,
        cameraCreds: {
          loading: true,
          error: null,
          data: {},
        },
      };
    }

    case types.GET_CAMERA_CREDS_SUCCESS: {
      return {
        ...state,
        cameraCreds: {
          loading: false,
          error: null,
          data: action.payload,
        },
      };
    }

    case types.GET_CAMERA_CREDS_FAILURE: {
      return {
        ...state,
        cameraCreds: {
          loading: false,
          error: action.payload,
          data: {},
        },
      };
    }

    case types.RESET_CAMERA_CREDS: {
      return {
        ...state,
        cameraCreds: {
          loading: false,
          error: null,
          data: {},
        },
      };
    }

    default:
      return state;
  }
};
export default deviceReducer;
